import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Footer } from '../../../../components/footer';
import GrHeader from '../../../../components/grHeader';
import Qrcode from '../../../../components/qrcode';
import { getRecruitDetailFromMoka } from '../../../../../services/api';
import { formatTime } from '@ifeng-fe/container_channel/common/client/winter/utils/formatTime';

import PropTypes from 'prop-types';
import ChipEdit from 'ChipEdit';

/**
 * for this page
 */

const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };
        state = {
            gwInfo: {},
            list: [],
            similarJob: [],
            jobname: '',
        };

        UNSAFE_componentWillMount() {
            console.log('did');
            const id = this.getId();

            // this.getList(id);
            this.getDetail(id);
        }
        componentDidMount() {}

        getDetail = async id => {
            // let params = { jobid: id };

            // params = encodeURIComponent(JSON.stringify(params));
            // const res = await getRecruitDetail(params);
            const res = await getRecruitDetailFromMoka(id);

            console.log('res===', res);

            if (res && res.data) {
                this.setState({
                    gwInfo: res.data,
                });
            }
        };

        // getList = async id => {
        //     const res = await getCampusList();

        //     const list = res.data;
        //     const gwInfo = this.formatData(list.filter(item => item._id === id));

        //     this.setState({
        //         list,
        //         gwInfo,
        //     });

        //     // this.getSimilar(gwInfo[0].jobType);
        //     let similarList = list.filter(item => item.jobType === gwInfo[0].jobType);

        //     similarList = similarList.length >= 5 ? similarList.slice(0, 4) : similarList;

        //     this.setState({
        //         similarJob: similarList,
        //     });
        // };
        // getid
        getId = () => {
            const url = window.location.href;
            const urlParams = url.indexOf('campus');
            const paraArray = url.substring(urlParams + 6);
            const searchInfo = this.trimSpace(paraArray.split('/'));

            return searchInfo[0];
        };
        trimSpace = array => {
            for (let i = 0; i < array.length; i++) {
                if (array[i] === '' || array[i] === ' ' || array[i] === null || typeof array[i] === 'undefined') {
                    array.splice(i, 1);
                    i -= 1;
                }
            }

            return array;
        };
        // 取相关
        getSimilar = type => {
            const data = this.state.list;
            let similarList = data.filter(item => item.jobType === type);

            similarList = similarList.length >= 5 ? similarList.slice(0, 4) : similarList;
            console.log('similar==', similarList);
            this.setState({
                similarJob: similarList,
            });
        };
        // 取日期
        formatTime = time => {
            const reg = new RegExp('/', 'g');
            const newtime = time.substring(0, 10).replace(reg, '-');

            return newtime;
        };

        // 格式化数据
        // formatData = data => {
        //     const newData = data.map((item, index) => ({
        //         jobId: item._id,
        //         jobTitle: item.jobTitle,
        //         jobType: item.jobType,
        //         jobDepart: item.jobDepart,
        //         jobAddress: item.jobAddress,
        //         jobKind: item.jobKind,
        //         jobStarttime: this.formatTime(item.jobStarttime),
        //         jobDesc: item.jobDesc,
        //         jobUrl: item.jobUrl,
        //     }));

        //     return newData;
        // };
        createChannelInfo = text => {
            return { __html: text };
        };

        render() {
            const { content } = this.props;

            const { header, qrCodeInfo } = content;
            const { gwInfo } = this.state;
            let applyUrl = '/job/apply/internship';

            applyUrl = gwInfo.id ? `${applyUrl}/${gwInfo.id}` : '';

            const duty = gwInfo.description || '';

            const gwInfoHtml = gwInfo.id ? (
                <div className={styles.mid_w783}>
                    <div className={`${styles.jobtex} ${styles.pt35}  ${styles.jobInfo}`}>
                        <p>
                            工作性质：<span>{gwInfo.commitment || ''}</span>
                        </p>
                        <p>
                            招聘人数： <span id="jobNum">{gwInfo.number || 0}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发布时间：<span>
                                {formatTime(gwInfo.publishedAt || '')}
                            </span>
                        </p>
                        <p>
                            工作地点：<span id="jobAddress">
                                {(gwInfo.locations && gwInfo.locations.length && gwInfo.locations[0].province) || ''}
                            </span>
                        </p>
                    </div>
                    <div className={`${styles.jobttitle} ${styles.mt44} ${styles.mb22}`}>{gwInfo.title}</div>
                    <div className={styles.jobtex}>
                        {duty !== '' ? <div dangerouslySetInnerHTML={this.createChannelInfo(duty)} /> : null}
                    </div>
                    <a id="applyJobBtn" className={styles.sub_sq} href={applyUrl}>
                        申请岗位
                    </a>
                </div>
            ) : (
                ''
            );

            return (
                <div>
                    <div className={styles.col}>
                        <GrHeader content={header} current={5} />
                        <div className={`${styles.col_w1000} clearfix`}>
                            <div className={styles.planBox}>{gwInfoHtml}</div>
                            <div className={`${styles.mid_w217} clearfix`}>
                                <div className={`${styles.box_xggw} ${styles.mt20}`} style={{ display: 'none' }} />
                            </div>
                        </div>
                    </div>
                    <Footer />
                    <Qrcode content={qrCodeInfo} />
                    <ChipEdit />
                </div>
            );
        }
    },
);

export { Layout };
export default Layout;
